

export function convertTimestamps(data: any): any {
  if (data === null || data === undefined) {
    return data;
  }

  if (data && typeof data.toDate === 'function') {
    return data.toDate();
  }

  if (Array.isArray(data)) {
    return data.map(convertTimestamps);
  }

  if (typeof data === 'object') {
    const result: any = {};
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        result[key] = convertTimestamps(data[key]);
      }
    }
    return result;
  }

  return data;
}
